import { Navigate } from "react-router";
import { useGetThicknessClassQuery } from "../../../apis/ThicknessClass.api";
import { PrimaryThicknessClass, ThicknessClass } from "../../../types/models/ThicknessClass";
import GradientCircularProgress from "../../../../share/components/progress/GradientCircularProgress";

export const ThicknessClassScoped = () => {
    const {
        data,
    } = useGetThicknessClassQuery(PrimaryThicknessClass.fromPath('scoped'))

    if (data) {
        const url = `/dashboard/thickness-classes/${data.id}?scoped=true`
        return <Navigate to={url} replace/>
    } else {
        return <>
            <GradientCircularProgress/>
        </>
    }
}
export default ThicknessClassScoped;
